import React from 'react';
import SEO from '../components/SEO';
import GetInTouch from '../components/GetInTouch';
import GetStarted from '../components/GetStarted';
import Header from '../components/Header';
import PricingPlans from '../components/PricingPlans';

const Home = () => {
  return (
    <>
      <SEO
        title="Coimbatore Crane Rental Service | Monthly & Hourly Crane Hire | Perumal Cranes"
        description="Leading crane rental service in Coimbatore offering hourly, monthly, and project-based crane hire. 10-200 ton capacity cranes available. Expert operators, competitive rates, 24/7 service. Best crane rental rates in Coimbatore!"
        keywords="Coimbatore crane rental, crane rental service Coimbatore, monthly crane rental Coimbatore, hourly crane hire, time-based crane rental, crane service rates Coimbatore, Perumal Crane Services, mobile crane rental, tower crane rental, crane hire Coimbatore, heavy lifting equipment, construction crane rental, industrial crane service, affordable crane rental Coimbatore, crane operators Coimbatore, crane rental near me"
        canonicalUrl="/"
        ogTitle="Coimbatore's Best Crane Rental Service - Hourly & Monthly Plans | Perumal Cranes"
        ogDescription="Professional crane rental in Coimbatore with flexible hourly and monthly plans. 10-200 ton capacity. Expert operators, competitive pricing, 24/7 availability. Get instant quote!"
      />
      <Header />
      <GetStarted />
      <PricingPlans />
      <GetInTouch />
    </>
  );
};

export default Home;